import { styled } from '@mui/material/styles';
import { RoundPaper, RoundPaperProps } from './roundPaper';
import { Stack, StackProps, Typography, TypographyProps } from '@mui/material';
import { JSXChildren } from '../../../libs/types';

export type PrimaryPaperProps = RoundPaperProps;

export function PrimaryPaper({ ...props }: PrimaryPaperProps) {
  return <RoundPaperStyled {...props} />;
}

const RoundPaperStyled = styled(RoundPaper)(({ theme }) => ({
  backgroundColor: `color-mix(in srgb, #fff 100%, ${theme.palette.primary.main} 8%)`,
}));

export type PrimaryPaperBlockProps = StackProps & {
  blockTitle?: JSXChildren;
  titleProps?: TypographyProps;
  paperProps?: PrimaryPaperProps;
  children?: JSXChildren;
};
export function PrimaryPaperBlock({ blockTitle, titleProps, paperProps, children, ...props }: PrimaryPaperBlockProps) {
  return (
    <Stack direction="column" {...props}>
      {blockTitle && (
        <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }} {...titleProps}>
          {blockTitle}
        </Typography>
      )}
      <PrimaryPaper {...paperProps}>{children}</PrimaryPaper>
    </Stack>
  );
}
